module.exports = __webpack_public_path__ + "static/media/product-icon.7d24b120.svg";